import FirestoreCollectionStore from '../../../modules/vuex-firestore/FirestoreCollectionStore'

const state = {}

const mutations = {}

const getters = {}

const actions = {}

function formatter({ characterKey }) {
  return { characterKey }
}

export default new FirestoreCollectionStore({
  $name: 'members',
  $formatter: formatter,
  state,
  mutations,
  getters,
  actions
})
